<template>
  <div>
		<!-- <video ref="video1" @canplaythrough="prepareVideo1" loop muted crossOrigin="anonymous" playsinline style="display:none;">
			<source src="@/assets/ROOM1_360.mp4">
		</video>
		<video ref="video2" @canplaythrough="prepareVideo2" loop muted crossOrigin="anonymous" playsinline style="display:none;">
			<source src="@/assets/ROOM2_360.mp4">
		</video> -->
    <div class="Canvas" ref="canvas" width="800" height="600"
      :style="(store.state.user.isOnKeypoint || store.state.isEnded || (store.state.isReady && !store.state.isStarted)) ? 'filter: blur(5px);' : 'filter: none;'"
    ></div>
  </div>
</template>

<script>
import Webgl from '@/components/panorama/Webgl'
import preloader from '@/components/panorama/loaders/preloader';
import emitter from '@/emitter'

export default {
  name: 'Canvas',
  data () {
    return {
      webgl: null,
      video1Ready: true,
      video2Ready: true,
      video1: null,
      video2: null,
      preloaderReady: false
    }
  },
  inject: ['store'],
  methods: {
    onResize() {
      if (this.webgl === null) return
      this.webgl.onResize()
    },
    checkLoading() {
      if (this.video1Ready && this.video2Ready && this.preloaderReady) {
        emitter.emit('LOADED')
        this.webgl = new Webgl(this.$refs.canvas, this.video1, this.video2)
        window.addEventListener('resize', this.onResize)
      }
    },
    prepareVideo1() {
      this.video1Ready = true
      this.checkLoading()
    },
    prepareVideo2() {
      this.video2Ready = true
      this.checkLoading()
    },
    createVideo(src) {
      const video = document.createElement('video');

      video.setAttribute('muted', true);
      video.setAttribute('loop', true);
      video.setAttribute('autoplay', false);
      video.setAttribute('preload', 'auto');
      video.setAttribute('crossorigin', 'anonymous');
      if (src.mp4) {
        this.createVideoSource(video, 'video/mp4', src.mp4)
      }
      if (src.webm) {
        this.createVideoSource(video, 'video/webm', src.webm)
      }

      return video;
    },
    createVideoSource(video, type, src) {
      const source = document.createElement('source');
      /* Attribute settings for my second source */
      source.setAttribute('src', src);
      source.setAttribute('type', type);
      video.appendChild(source);
    }
  },
  mounted() {
    var manifest = [
      {type: 'Texture', url: require('@/assets/images/texture-keypoint.png'), id: 'kpMap'},
      {type: 'Texture', url: require('@/assets/images/alpha-keypoint.png'), id: 'kpAlphaMap'},
      {type: 'Audio', url: require('@/assets/audio/bambous.mp3'), id: 'audioR2'},
      {type: 'Audio', url: require('@/assets/audio/clairiere.mp3'), id: 'audioR1'},
      {type: 'Image', url: require('@/assets/bali-background.jpg'), id: 'i1'},
      {type: 'Image', url: require('@/assets/images/qr-code.png'), id: 'i2'},
    ];

    this.video1 = this.createVideo({
      mp4: require('../../assets/ROOM15sec.mp4'),
      webm: require('../../assets/ROOM15sec.webm')
    })
    this.video2 = this.createVideo({
      mp4: require('../../assets/ROOM25sec.mp4'),
      webm: require('../../assets/ROOM25sec.webm')
    })
    preloader.load(manifest, () => {
      this.preloaderReady = true
      this.checkLoading()
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
    this.webgl.destroy()
  }
}
</script>

<style lang="stylus" scoped>
  .Canvas
    width 100%
    height 100%
    position absolute
    border 1px solid black
</style>